import React from 'react';
import StickyNote from './sticky-note/sticky-note';
import { useBannerData } from '../shared';
import Menus from './menus/menus';
import './header.scss';
export default function Header() {
    const bannerData = useBannerData();
    return (React.createElement("div", { className: "page-header" },
        React.createElement(StickyNote, { bannerData: bannerData }),
        React.createElement(Menus, null)));
}
